import { Component, Input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import type {
  CardOrderShipmentCarrier,
  CardOrderUpsPackageDetails,
  UpsShippingLabelDialogItem,
} from "../card-orders.interface";
import {
  getShipmentCarrierLabelKey,
  getUpsPackageStatus,
  isUpsPackageDelivered,
} from "../card-order.util";
import { UpsShippingLabelsDialogComponent } from "../ups-shipping-labels-dialog/ups-shipping-labels-dialog.component";

@Component({
  selector: "app-ups-packages-tracking",
  templateUrl: "./ups-packages-tracking.component.html",
  styleUrls: ["./ups-packages-tracking.component.scss"],
  standalone: false,
})
export class UpsPackagesTrackingComponent {
  @Input() packages: CardOrderUpsPackageDetails[] = [];
  @Input() shipmentDescription: string | null = null;
  @Input() shipmentCarrier: CardOrderShipmentCarrier | null = null;

  historyExpandedIds: Record<string, boolean> = {};

  readonly getPackageStatus = getUpsPackageStatus;
  readonly isPackageDelivered = isUpsPackageDelivered;
  readonly getShipmentCarrierLabelKey = getShipmentCarrierLabelKey;

  constructor(private readonly dialog: MatDialog) {}

  isHistoryExpanded(packageId: string): boolean {
    return Boolean(this.historyExpandedIds[packageId]);
  }

  toggleHistory(packageId: string): void {
    this.historyExpandedIds = {
      ...this.historyExpandedIds,
      [packageId]: !this.historyExpandedIds[packageId],
    };
  }

  activityCount(pkg: CardOrderUpsPackageDetails): number {
    return pkg.tracking?.activities?.length ?? 0;
  }

  packageStage(pkg: CardOrderUpsPackageDetails): string {
    if (this.isPackageDelivered(pkg)) {
      return "DELIVERED";
    }
    if (pkg.tracking?.statusType === "I" || pkg.tracking?.statusType === "D") {
      return "IN_TRANSIT";
    }
    return "SHIPPED";
  }

  hasShippingLabel(pkg: CardOrderUpsPackageDetails): boolean {
    return Boolean(pkg.shippingLabelGifBase64?.trim());
  }

  openShippingLabel(
    pkg: CardOrderUpsPackageDetails,
    packageIndex: number,
  ): void {
    const shippingLabelGifBase64 = pkg.shippingLabelGifBase64?.trim() ?? "";
    if (!shippingLabelGifBase64) {
      return;
    }

    const labels: UpsShippingLabelDialogItem[] = [
      {
        index: packageIndex,
        trackingNumber: pkg.trackingNumber,
        packageDescription: pkg.packageDescription,
        shippingLabelGifBase64,
      },
    ];

    this.dialog.open(UpsShippingLabelsDialogComponent, {
      width: "960px",
      maxWidth: "96vw",
      panelClass: "app-dialog-panel",
      data: { labels },
    });
  }
}
